/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import Home from "layouts/pages/home";

// Material Kit 2 React routes
import routes from "routes";

//
import SignUpBasic from "pages/Auth/SignUp";
import SignInBasic from "pages/Auth/SignIn";
import SignInViaOtpBasic from "pages/Auth/SignInViaOtp";
import { ErrorProvider } from "hooks/ErrorContext";
import { SuccessProvider } from "hooks/SuccessContext";
import { AuthProvider } from "hooks/AuthContext";
import AdminRoute from "routes/adminRoutes";
import Unauthorized from "pages/unauthorized";
import { FinishSignInViaEmail } from "pages/Auth/SignInViaOtp/signInViaEmail";
import CCRoute from "routes/ccRoutes";
import CCPanelUsers from "pages/CC/allUsers";
import './index.css';
import Layout from "components/SchoolLayout/schoolLayout";
import FindAlumini from "pages/LandingPages/FindAlumini";
import UserRoute from "routes/userRoutes";
import GatePass from "pages/LandingPages/Gatepass";
import IcardComponent from "pages/LandingPages/ICard";
import ManageFeed from "pages/Admin/manageFeeds";
import AdminLayoutComponent from "components/AdminLayout/adminLayout";
import ManageEvent from "pages/Admin/manageEvent";
import MaintenancePage from "pages/maintenance";
import UpdatePersonalDetails from "pages/LandingPages/UpdatePersonalDetails";
import ViewUsers from "pages/Admin/viewUsers";
import GatePasses from "pages/Admin/gatePasses";

export default function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const adminNavigation = [
    {
      category: "Main",
      items: [
        { path: "/", label: "Dashboard", icon: "home" },
        { path: "/admin/feeds", label: "Manage Feeds", icon: "fa-solid fa-photo-film" },
        { path: "/admin/events", label: "Manage Events", icon: "fa-solid fa-calendar-week" },
        { path: "/admin/gate-passess", label: "View Passess", icon: "fa-solid fa-key" },
      ],
    },
    {
      category: "Management",
      items: [
        { path: "/admin/users", label: "Users", icon: "users" },
        { path: "/settings", label: "Settings", icon: "cog" },
      ],
    },
  ];

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <AuthProvider>
      <ErrorProvider>
        <SuccessProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<Home />} />
                  {/* Auth Related */}
                <Route exact path="/pages/authentication/sign-up" element={<SignUpBasic />} />
                <Route exact path="/pages/authentication/sign-in" element={<SignInBasic />} />
                <Route
                exact
                path="/pages/authentication/sign-in-via-otp"
                element={<SignInViaOtpBasic />}
                />

              </Route>
              <Route path="/maintenance" element={<MaintenancePage />} />



              <Route
                path="/user/*"
                element={
                  <UserRoute>
                    <Routes><Route path="" element={<Layout />}>
                      <Route path="alumini" element={<FindAlumini />} />
                      <Route path="gatepass" element={<GatePass />} />
                      <Route path="icard" element={<IcardComponent />} />
                      <Route path="myProfile" element={<UpdatePersonalDetails />} />
                    </Route></Routes>

                  </UserRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <AdminRoute>
                    <Routes>
                    <Route element={<AdminLayoutComponent   navigationItems={adminNavigation}/>}>
                        <Route path="feeds" element={<ManageFeed />} />
                        <Route path="events" element={<ManageEvent />} />
                        <Route path="users" element={<ViewUsers />} />
                        <Route path="gate-passess" element={<GatePasses />} />
                        </Route>
                    </Routes>
                  </AdminRoute>
                }
              />
               <Route
                path="/cc/*"
                element={
                  <CCRoute element={<AdminLayoutComponent />}>
                    <Routes>
                      <Route path="users" element={<CCPanelUsers />} />
                    </Routes>
                  </CCRoute>
                }
              />

              {getRoutes(routes)}
              <Route path="/*" element={<Navigate to="/home" />} />

              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/finishSignUpViaEmail" element={<FinishSignInViaEmail />} />
            </Routes>
          </ThemeProvider>
        </SuccessProvider>
      </ErrorProvider>
    </AuthProvider>
  );
}
